import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const CURRENT_COMPANY_TAGS = Object.freeze({
  TOP_ITEMS: 'current_company_top_items',
});

export const currentCompanyApiSlice = createApi({
  reducerPath: 'currentCompanyApiSlice',
  baseQuery,
  tagTypes: Object.values(CURRENT_COMPANY_TAGS),
  endpoints: (builder) => ({
    getCurrentCompanyTopItems: builder.query({
      query: ({ apiManager, params }) => apiManager.getTopItems(params),
      providesTags: [CURRENT_COMPANY_TAGS.TOP_ITEMS],
    }),
  }),
});

export const { useGetCurrentCompanyTopItemsQuery } = currentCompanyApiSlice;
